import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';

import {TextField, Dialog, DialogActions, DialogContent, Button} from '@material-ui/core';

const PseudoModal = ({open, onSubmit}) => {
  const {t} = useTranslation();
  const [pseudo, setPseudo] = useState('');
  const [city, setCity] = useState('');

  const submit = () => {
    if (pseudo.trim() && city.trim()) {
      return onSubmit(`${pseudo.trim()} - ${city.trim()}`);
    }
    return onSubmit(null);
  };

  const handlePseudoChange = e => {
    setPseudo(e.target.value);
  };
  const handleCityChange = e => {
    setCity(e.target.value);
  };

  return (
    <Dialog open={open}>
      <DialogContent>
        {/* <DialogContentText>
                To subscribe to this website, please enter your email address here. We will send updates occasionally.
              </DialogContentText> */}
        <TextField
          autoFocus
          id="name"
          label={t('your-firstname')}
          type="text"
          fullWidth
          variant="standard"
          onChange={handlePseudoChange}
        />
        <TextField
          id="city"
          label={t('your-city')}
          type="text"
          fullWidth
          variant="standard"
          onChange={handleCityChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={submit}>{t('access-chat')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PseudoModal;
